<template>
    <section class="comp_bookings_edit">
        <div class="comp_scroller" v-show="subScreen !== 'guest'">
            <div class="comp_content">
                <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle">
                    <div class="col">
                        <h1 class="part_ui_heading">
                            <span>{{ id && row ? `${$t('edit_booking')} ${id}` : $t('new_booking') }}</span></h1>
                    </div>
                </header>
                <div class="wrp_comp_body">
                    <div class="part_edit">
                        <div v-if="!subScreen && values" :class="[loading ? 'state-loading' : '']">
                            <div :class='{elm_item: true, required: !values.name}'>
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="name" class="elm_label"><span>{{ $t('label') }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_input">
                                            <input type="text" id="name" v-model="values.name"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class='{elm_item: true, required: !values.source_id}'>
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="source_id" class="elm_label"><span>{{ $t('source') }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_select">
                                            <custom-search-select
                                                v-model="values.source_id"
                                                :options="selectSources"
                                                :id-func="o=>o.id"
                                                :label-func="o=>`${o.name} (${ o.code })`"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="elm_item">
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="order_number" class="elm_label"><span>{{
                                                $t('order_num')
                                            }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_input">
                                            <input type="text" id="order_number" v-model="values.order_number" min="0">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="elm_item">
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <div class="elm_label"><span>{{ $t('group') }}</span></div>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <label class="part_ui_switch">
                                            <input id="group" type="checkbox" v-model="values.is_group">
                                            <span></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div :class='{elm_item: true, "mod--mt-24":true, required: !check_in_date}'>
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="check_in_date" class="elm_label"><span>{{
                                                $t('arrival')
                                            }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_input">
                                            <date-input :value="check_in_date?moment(check_in_date).toDate():undefined"
                                                        :minDate="id ? undefined : moment().startOf('d').toDate()"
                                                        :maxDate="check_out_date ? moment(check_out_date).startOf('d').subtract(1,'d').toDate() : undefined"
                                                        v-on:input="(v)=>{check_in_date = moment(v).format('YYYY-MM-DD') ;createDefaultPriceMask(); getSelectRoomNumbers();}"
                                                        required/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class="{elm_item: true, required: !check_out_date}">
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="check_out_date" class="elm_label"><span>{{ $t('departure') }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_input">
                                            <date-input
                                                :value="check_out_date?moment(check_out_date).toDate():undefined"
                                                :minDate="moment.max(
                                                    ...(check_in_date?[moment(check_in_date).add(1,'d').startOf('d')]:[]),
                                                    ...(id ? [] : [moment().add(1,'d').startOf('d')])
                                                    ).toDate()"
                                                v-on:input="(v)=>{check_out_date = moment(v).format('YYYY-MM-DD') ;createDefaultPriceMask(); getSelectRoomNumbers();}"
                                                required/>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div :class='{elm_item: true, "mod--mt-24":true, required: !values.room_type_id}'>
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="room_type_id" class="elm_label"><span>{{
                                                $t('room_type')
                                            }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_select">
                                            <custom-search-select
                                                v-model="values.room_type_id"
                                                @input="getSelectRoomNumbers();"
                                                :options="selectRoomTypes"
                                                :id-func="o=>o.id"
                                                :label-func="o=>`${o.description} (${ o.code })`"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class='{elm_item: true, required: !values.room_count}'>
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="room_count" class="elm_label"><span>{{
                                                $t('number_of_rooms')
                                            }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_select">
                                            <custom-search-select
                                                v-model="values.room_count"
                                                :options="selectRoomCount"
                                                :id-func="o=>o"
                                                :label-func="o=>o.toString()"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class='{elm_item: true, required: !values.guest_count}'>
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="guest_count" class="elm_label"><span>{{
                                                $t('number_of_people')
                                            }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_select">
                                            <custom-search-select
                                                v-model="values.guest_count"
                                                :options="selectGuestCount"
                                                :id-func="o=>o"
                                                :label-func="o=>o"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="guest-block" v-for="(_, index) in values.guest_count">
                                <div class="title">
                                    <label style="flex:1">
                                        {{ $t('guest') }} {{ (index + 1) }}
                                        {{ index === 0 ? '(' + $t('master') + ')' : '' }}
                                    </label>
                                    <button v-on:click="$router.push(`/bookings/edit/${id}/${row}/guest/${index}`)"
                                            :disabled="!getGuestValue(index, g=>g.id)">
                                        <span class="icon icon--person-fill"/>{{ $t('guest_card') }}
                                    </button>
                                </div>
                                <div class="elm_item">
                                    <div class="mod--row mod--row-flex mod--row-middle">
                                        <div class="col col--6">
                                            <label v-bind:for="'guest_count_' + index"
                                                   class="elm_label"><span>{{ $t('room_number') }} host {{
                                                    index + 1
                                                }}</span></label>
                                        </div>
                                        <div class="col col--6 mod--right">
                                            <div
                                                :class="`part_ui_select room_select ${getGuestValue(index, g=>g.checked_in)?'disabled':''}`">
                                                <custom-search-select
                                                    :value="getGuestValue(index, g=>g.room_id)"
                                                    v-on:input="changeGuest(index, g=>g.room_id = $event)"
                                                    :options="selectRoomNumbersForGuest(index)"
                                                    :id-func="o=>o.id"
                                                    :disabled="getGuestValue(index, g=>g.checked_in)"
                                                    :label-func="o=>o.code"/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <edit-item :label="$t('surname')" :labelFor="`guest_${index}_surname`"
                                           :required="!getGuestValue(index,g=>g.profile.last_name) &&
                                           (index === 0 || getGuestValue(index,g=>g.room_id)) /*Jen u prvního hosta nebo pokud má zadaný pokoj*/">
                                    <div class="part_ui_input">
                                        <input :id="`guest_${index}_surname`"
                                               :value="getGuestValue(index,g=>g.profile.last_name)"
                                               v-on:input="changeGuest(index, g=>g.profile.last_name = $event.target.value)"/>
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('name')" :labelFor="`guest_${index}_name`">
                                    <div class="part_ui_input">
                                        <input :id="`guest_${index}_name`"
                                               :value="getGuestValue(index, g=>g.profile.first_name)"
                                               v-on:input="changeGuest(index, g=>g.profile.first_name = $event.target.value)"/>
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('email')" :labelFor="`guest_${index}_email`">
                                    <div class="part_ui_input">
                                        <input :id="`guest_${index}_email`"
                                               :value="getGuestValue(index, g=>g.profile.email_address)"
                                               v-on:input="changeGuest(index, g=>g.profile.email_address = $event.target.value)"/>
                                    </div>
                                </edit-item>
                            </div>
                            <div :class='{elm_item: true, "mod--mt-32":true, required: !pricelist_id}'>
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="pricelist_id" class="elm_label"><span>{{
                                                $t('pricelist')
                                            }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_select">
                                            <custom-search-select
                                                v-model="pricelist_id"
                                                :options="selectPriceLists"
                                                :id-func="o=>o.id"
                                                :label-func="o=>o.name"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div :class='{elm_item: true, "mod--mt-8":true, required: !pricetype_id}'>
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="pricetype_id" class="elm_label"><span>{{ $t('price_type') }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_select">
                                            <custom-search-select
                                                v-model="pricetype_id"
                                                :options="selectPriceTypes"
                                                v-on:input="createDefaultPriceMask()"
                                                :id-func="o=>o.id"
                                                :label-func="o=>o.code"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                :class="`elm_item mod--mt-48 ${!noPriceMaskUsed && !isPriceMaskFilled() ? 'required':''}`">
                                <div class="mod--row mod--row-flex mod--row-middle"
                                     v-on:click="$router.push( id && row ?`/bookings/edit/${id}/${row}/priceMask`: '/bookings/new/priceMask')">
                                    <div class="col col--6">
                                        <label for="price_mask_text" class="elm_label"><span>{{
                                                $t('price_mask')
                                            }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_input">
                                            <input id="price_mask_text" v-model="price_mask_text" type="text" readonly>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style="padding: 12px 0;margin-bottom: 16px"
                                 v-if="Number.isFinite(Number(values.total_price_per_room))">
                                <edit-item :label="$t('price_per_room_and_night')" class="naked">
                                    <div>{{
                                            (Number(values.total_price_per_room) / values.room_count / values.nights).toFixed(2)
                                        }} {{ this.currency }}
                                    </div>
                                </edit-item>
                                <edit-item :label="$t('price_total')" class="naked">
                                    <div>{{ Number(values.total_price_per_room).toFixed(2) }} {{ this.currency }}</div>
                                </edit-item>
                            </div>
                            <div class="elm_item mod--mt-48">
                                <div class="mod--row mod--row-flex mod--row-middle">
                                    <div class="col col--6">
                                        <label for="note" class="elm_label"><span>{{ $t('note') }}</span></label>
                                    </div>
                                    <div class="col col--6 mod--right">
                                        <div class="part_ui_input" style="width: 100%">
                                            <textarea id="note" v-autosize="values.note"
                                                      v-model="values.note"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="elm_part_buttons mod--row mod--row-12 mod--row-flex mod--flex-wrap">
                                <div class="col col--6-t col--12-m">
                                    <button type="submit" class="part_ui_btn part_ui_btn_primary mod--block"
                                            v-on:click="submit"
                                            :disabled="!mandatoryFilled"><span>{{
                                            $t('save_booking')
                                        }}</span>
                                    </button>
                                </div>
                                <template v-if="id">
                                    <div v-if="canceled" class="col col--6-t col--12-m">
                                        <button type="submit" class="part_ui_btn part_ui_btn_outline mod--block"
                                                v-on:click="uncancel">
                                            <span>{{ $t('uncancel_booking') }}</span></button>
                                    </div>
                                    <div v-else class="col col--6-t col--12-m">
                                        <button type="submit"
                                                class="part_ui_btn part_ui_btn_outline mod--color-error mod--block"
                                                v-on:click="cancel"><span>{{ $t('cancel_booking') }}</span></button>
                                    </div>
                                </template>
                            </div>
                        </div>

                        <div v-if="subScreen === 'priceMask'">
                            <price-mask-edit
                                :price-mask-map="price_mask"
                                :from="check_in_date"
                                :to="check_out_date"
                                :on-change="priceMaskChanged"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="comp_scroller" v-if="subScreen==='guest'">
            <div class="comp_content">
                <div class="wrp_comp_body">
                    <div class="part_edit">
                        <guest-profile-detail :profile="guests[Number(subScreenItemId)].profile"
                                              :note="guests[Number(subScreenItemId)].note"/>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import CustomSearchSelect from '../part/ui/custom-search-select.vue';
import {computePriceMaskText, priceMaskArrayToMap, sanitize} from '../../main';
import PriceMaskEdit from '../part/price-mask-edit.vue';

export default {
    name: 'bookings-edit',
    components: {PriceMaskEdit, CustomSearchSelect},
    watch: {
        pricelist_id: function () {
            this.getPriceTypes();

            if (!this.id) {
                const priceList = this.selectPriceLists.find(l => l.id === this.pricelist_id)
                if (priceList) {
                    this.currency = priceList.accommodation_currency.code_iso
                }
            }
        },
        $route: function () {
            this.parseRoute()
        },
        'values.name': function () {
            if (this.enableGuestNamePrefill) {
                this.changeGuest(0, g => {
                    const parts = this.values.name.split(/\s/)
                    g.profile.last_name = parts.length > 0 ? parts[0] : ''
                    g.profile.first_name = parts.slice(1).join(' ').trim()
                }, false)
            }
        },
        price_mask: function () {
            this.computePriceMaskText();
        },
        'values.guest_count': function () {
            const newGuests = [...this.guests]
            for (let i = 0; i < this.values.guest_count; ++i) {
                if (!newGuests[i]) {
                    newGuests[i] = this.createDefaultGuest()
                }
            }
            this.guests = newGuests
        },
        currency: function () {
            this.computePriceMaskText()
        }
    },
    data() {
        return {
            moment: moment,
            loading: false,
            currency: null,
            id: null,
            row: null,
            check_in_date: null,
            check_out_date: null,
            pricelist_id: null,
            pricetype_id: null,
            price_mask: new Map(),
            guests: [],
            values: {
                source_id: undefined,
                guest_count: undefined,
                room_count: undefined,
                room_type_id: undefined
            },
            selectSources: [],
            selectRoomTypes: [],
            selectPriceTypes: [],
            selectPriceLists: [],
            selectPriceMasks: [],
            selectRoomCount: [
                1, 2, 3, 4, 5
            ],
            selectGuestCount: [
                1, 2, 3, 4, 5, 6, 7, 8, 9, 10
            ],
            selectRoomNumbers: [],
            price_mask_text: null,
            selectPriceTypesAll: [],
            subScreen: undefined,
            subScreenItemId: undefined,
            canceled: false,
            enableGuestNamePrefill: true,
            enablePriceMaskAutofill: false,
            noPriceMaskUsed: false
        }
    },
    mounted() {
        let self = this;
        let a = this.getSelectSources();
        let b = this.getSelectRoomTypes();
        let c = this.getSelectPriceTypes();

        this.id = this.$route.params.id;
        this.row = this.$route.params.row;

        this.check_in_date = this.$route.query.from ? moment(this.$route.query.from).format('yyyy-MM-DD') : undefined
        this.check_out_date = this.$route.query.to ? moment(this.$route.query.to).format('yyyy-MM-DD') : undefined

        if (this.$route.query.room_type_id) {
            this.values.room_type_id = Number.parseInt(this.$route.query.room_type_id)
            this.values.room_count = 1
            this.values.guest_count = 1
            this.guests[0] = this.createDefaultGuest();
            this.guests[0].room_id = Number.parseInt(this.$route.query.room_id)

            this.getSelectRoomNumbers()
        }

        if (this.id) {
            this.loading = true;
            Promise.all([a, b, c]).then(function (values) {
                self.getReservationData();
                self.loading = false;
            });
        } else {
            this.enablePriceMaskAutofill = true
        }

        this.parseRoute()
    },
    computed: {
        mandatoryFilled() {
            return this.values &&
                this.values.name &&
                this.values.source_id &&
                this.values.room_type_id &&
                this.values.room_count &&
                this.values.guest_count &&
                this.check_in_date &&
                this.check_out_date &&
                this.pricelist_id &&
                this.pricetype_id &&
                (this.noPriceMaskUsed || this.isPriceMaskFilled()) &&
                this.guests.length >= this.values.guest_count &&
                this.guests.every((g, index) => (index > 0 && !g.room_id) || g.profile.last_name)
        }
    },
    methods: {
        priceMaskChanged(newPriceMaskMap) {
            this.price_mask = newPriceMaskMap
            this.enablePriceMaskAutofill = false;
            this.noPriceMaskUsed = false
            this.$router.back();
        },
        isPriceMaskFilled() {
            const ret = [];

            if (this.check_in_date && this.check_out_date) {
                let from = new moment(this.check_in_date);
                let to = new moment(this.check_out_date);

                for (let m = moment(from); m.isBefore(to); m.add(1, 'days')) {
                    if (!this.price_mask.get(moment(m).format('YYYY-MM-DD'))) {
                        return false
                    }
                }
            }

            return true;
        },
        setPriceMaskFromArray(priceMaskArray) {
            this.price_mask = priceMaskArrayToMap(priceMaskArray);
        },
        selectRoomNumbersForGuest(index) {
            let ret = [...this.selectRoomNumbers]

            this.guests.forEach(guest => {
                if (guest && guest.room && !ret.some(r => r.id === guest.room.id)) {
                    ret.push(guest.room)
                }
            })

            return ret;
        },
        parseRoute() {
            this.id = this.$route.params.id;
            this.row = this.$route.params.row;
            this.subScreen = this.$route.params.subScreen;
            this.subScreenItemId = this.$route.params.subScreenItemId;
        },
        getGuestValue(index, getter) {
            const g = this.guests[index]
            return g ? getter(g) : undefined
        },
        changeGuest(index, modifier, disableGuestNamePrefill = true) {
            const guests = [...this.guests]
            let g = guests[index]
            if (!g) {
                g = this.createDefaultGuest()
                guests[index] = g
            }

            modifier(g)

            this.guests = guests
            if (disableGuestNamePrefill) {
                this.enableGuestNamePrefill = false
            }
        },
        createDefaultGuest() {
            return {
                room_id: undefined,
                profile: {
                    last_name: '',
                    first_name: '',
                    email_address: ''
                }
            }
        },
        getPriceTypes() {
            let self = this;
            let selectPriceTypes = [];

            if (this.pricelist_id) {
                this.selectPriceTypesAll.forEach(function (item) {
                    if (parseInt(item.pricelist_id) === parseInt(self.pricelist_id)) {
                        selectPriceTypes.push(item);
                    }
                });
            }

            this.selectPriceTypes = selectPriceTypes;
        },
        computePriceMaskText() {
            this.price_mask_text = computePriceMaskText(this.price_mask, this.currency)
        },
        createDefaultPriceMask: function () {
            if (this.enablePriceMaskAutofill && this.check_in_date && this.check_out_date && this.pricetype_id) {
                axios({
                    data: `{
                            listPriceListPrices(date_from: "${moment(this.check_in_date).format('YYYY-MM-DD')}", date_to: "${moment(this.check_out_date).subtract(1, 'day').format('YYYY-MM-DD')}", price_type_id: ${this.pricetype_id}) {
                                price
                                price_date
                            }
                        }`
                }).then(response => {
                    let priceMaskArray;
                    if (response.data.data.listPriceListPrices) {
                        priceMaskArray = response.data.data.listPriceListPrices.map(i => ({
                            date: moment(i.price_date).format('YYYY-MM-DD'),
                            price: i.price
                        }))
                    } else {
                        priceMaskArray = []
                    }
                    this.setPriceMaskFromArray(priceMaskArray)
                }).catch(error => {
                    this.showError(error)
                });
            }
        },
        getSelectSources: function () {
            return axios({
                data: `{
                        listReservationSources {
                          id
                          code
                          name
                        }
                      }`
            }).then(response => {
                this.selectSources = response.data.data.listReservationSources;
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectRoomTypes: function () {
            return axios({
                data: `{
                        listRoomTypes {
                          id
                          code
                          description
                        }
                      }`
            }).then(response => {
                this.selectRoomTypes = response.data.data.listRoomTypes;
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectPriceTypes: function () {
            return axios({
                data: `{
                        listPriceLists(deleted: false) {
                          id
                          name
                          price_types {
                            id
                            code
                          }
                          accommodation_currency {
                            code_iso
                          }
                        }
                      }`
            }).then(response => {
                this.selectPriceLists = response.data.data.listPriceLists;

                let priceTypes = [];

                response.data.data.listPriceLists.forEach(function (item) {
                    item.price_types.forEach(function (itm) {
                        itm.pricelist_id = item.id;
                        priceTypes.push(itm);
                    });
                });

                this.selectPriceTypesAll = priceTypes;
            }).catch(error => {
                this.showError(error)
            });
        },
        getSelectRoomNumbers: function () {
            if (this.check_in_date && this.check_out_date && this.values.room_type_id) {
                console.log(this.check_in_date)
                console.log(this.values.room_type_id)
                const query = `{
                    listAvailableRooms(free_from: "${this.check_in_date}", free_to: "${this.check_out_date}", room_type_id: ${this.values.room_type_id}, available_only: true ${this.id ? `, filter_reservation_number: ${this.id}` : ''})
                    {
                        id
                        code
                    }
                }`

                return axios({
                    data: query
                }).then(response => {
                    this.selectRoomNumbers = response.data.data.listAvailableRooms;
                }).catch(error => {
                    this.showError(error)
                });
            } else {
                this.selectRoomNumbers = []
            }
        },
        getReservationData: function () {
            this.enableGuestNamePrefill = false

            let self = this;
            let data = `{
                        id
                        name
                        source_id
                        is_group
                        created_at
                        order_number
                        note
                        reservation_rows {
                            id
                            check_in_date
                            check_out_date
                            room_type_id
                            room_count
                            guest_count
                            pricelist_id
                            pricetype_id
                            total_price_per_room
                            nights
                            prices {
                                date
                                price
                            }
                            guests {
                                id
                                room_id
                                checked_in
                                room {
                                    id
                                    code
                                }
                                profile {
                                    id
                                    full_name
                                    first_name
                                    last_name
                                    email_address
                                    phone_number
                                    address_street
                                    address_zip
                                    address_town
                                    address_hn
                                    country_id
                                    note
                                    citizenship_id
                                    ic_number
                                    birth_date
                                    birth_town
                                    licence_plate
                                }
                                note
                            }
                            canceled
                        }
                        accommodation_currency {
                            code_iso
                        }
                      }`;
            let query = `{getReservation(reservation_number: ${this.id}) ${data}}`;

            axios({
                data: query
            }).then(response => {
                let res = response.data.data.getReservation;

                self.currency = res.accommodation_currency.code_iso

                let values = {
                    name: res.name,
                    source_id: res.source_id,
                    is_group: res.is_group,
                    created_at: res.created_at,
                    order_number: res.order_number,
                    note: res.note,
                };

                res.reservation_rows.forEach(function (item) {
                    if (parseInt(item.id) === parseInt(self.row)) {
                        self.check_in_date = item.check_in_date;
                        self.check_out_date = item.check_out_date;
                        values.guest_count = item.guest_count;
                        self.pricelist_id = item.pricelist_id;
                        self.pricetype_id = item.pricetype_id;
                        values.room_count = item.room_count;
                        values.room_type_id = item.room_type_id;
                        values.total_price_per_room = item.total_price_per_room;
                        values.nights = item.nights;
                        self.guests = item.guests.sort((a, b) => ((a.room_id ? a.room_id : Infinity) - (b.room_id ? b.room_id : Infinity)) || (a.id - b.id));
                        self.canceled = item.canceled;

                        if (!item.prices || item.prices.length === 0) {
                            self.noPriceMaskUsed = true
                        } else {
                            self.setPriceMaskFromArray(item.prices.map(i => ({
                                date: moment(i.date).format('YYYY-MM-DD'),
                                price: i.price
                            })))
                        }
                    }
                });

                this.values = values;

                this.getPriceTypes();
                this.getSelectRoomNumbers();
            }).catch(error => {
                this.showError(error)
            });
        },
        objectToGraphiQl: function (item) {
            let res = '';
            if (typeof item === 'object') {
                res += '{'
                res += Object.entries(item).map(([prop, val]) => {
                    let valStr;
                    if (Number.isInteger(val)) {
                        valStr = val.toString()
                    } else if (val === null || val === undefined) {
                        valStr = 'null'
                    } else if (typeof val === 'object') {
                        valStr = this.objectToGraphiQl(val)
                    } else {
                        valStr = `"${val}"`
                    }
                    return `${prop}: ${valStr}`
                }).join('\n')

                res += '}'
            }
            return res;
        },
        submit: function () {
            let self = this;

            // prices assemble
            let pricesQuery = '[';
            let prices = [];
            this.price_mask.forEach((price, date) => {
                if (moment(date).isBetween(this.check_in_date, this.check_out_date, 'day', '[)')) {
                    prices.push(`{date: "${moment(date).format('YYYY-MM-DD')}", price: ${price}}`);
                }
            });
            pricesQuery += prices.join(',');
            pricesQuery += ']';

            // guests assemble
            let guestsQuery = '[';
            let guests = [];
            this.guests.forEach((item, index) => {
                if (index < this.values.guest_count) {
                    let newGuest = {};

                    if (item.id) {
                        newGuest.id = item.id
                    }

                    // Pokud checked_in, nesmím zadávat pokoj
                    if (!item.checked_in) {
                        newGuest.room_id = item.room_id
                    }

                    newGuest.profile = {
                        id: item.profile.id,
                        last_name: sanitize(item.profile.last_name),
                        first_name: sanitize(item.profile.first_name),
                        email_address: sanitize(item.profile.email_address)
                    }

                    guests.push(newGuest)
                }
            });

            guestsQuery += guests.map(g => this.objectToGraphiQl(g)).join(',')
            guestsQuery += ']'

            let data = `{
                            ${this.id ? 'id:' + this.id : ''}
                            name: "${sanitize(this.values.name)}"
                            source_id: ${this.values.source_id}
                            is_group: ${!!this.values.is_group}
                            created_at: "${this.values.created_at ? this.values.created_at : moment().toISOString()}"
                            order_number: "${this.values.order_number ? sanitize(this.values.order_number) : ''}"
                            note: "${this.values.note ? sanitize(this.values.note).replace(/(\r\n|\n|\r)/gm, ' ') : ''}"
                            reservation_rows: [
                                {
                                    ${this.row ? 'id: ' + this.row : ''}
                                    check_in_date: "${this.check_in_date}"
                                    check_out_date: "${this.check_out_date}"
                                    room_type_id: ${this.values.room_type_id}
                                    room_count: ${this.values.room_count}
                                    guest_count: ${this.values.guest_count}
                                    pricelist_id: ${this.pricelist_id}
                                    pricetype_id: ${this.pricetype_id}
                                    prices: ${pricesQuery}
                                    guests: ${guestsQuery}
                                }
                            ]
                        }`;

            let query = `mutation createReservation {
                    createUpdateReservation(reservation: ${data}) {
                        ok
                    }
                }`;

            axios({
                data: query
            }).then(response => {
                if (response.data.data.createUpdateReservation.ok) {
                    this.$dialog.alert('Rezervace uložena', {okText: 'Ok'}).then(function (dialog) {
                        //self.$router.push('/bookings/overview')
                        self.$router.back()
                    });
                } else {
                    this.$dialog.alert(this.$t('room_already_booked'), {okText: 'Ok'});
                }
            }).catch(error => {
                this.showError(error)
            });
        },
        cancel: function () {
            let self = this;

            self.$dialog.confirm(self.$t('really_cancel'), {okText: self.$t('yes'), cancelText: self.$t('no')})
                .then(() => {
                    let data = `{
                            ${this.id ? 'id:' + this.id : ''}
                            reservation_rows: [
                                {
                                    ${this.row ? 'id: ' + this.row : ''}
                                    canceled: true
                                }
                            ]
                        }`;

                    let query = `mutation createReservation {
                    createUpdateReservation(reservation: ${data}) {
                        ok
                    }
                }`;

                    axios({
                        data: query,
                        timeout: 10000,
                    }).then(response => {
                        if (response.data.data.createUpdateReservation.ok) {
                            self.canceled = true;
                            this.$dialog.alert(self.$t('reservation_canceled'), {okText: 'OK'});
                        } else {
                            this.$dialog.alert(self.$t('error_canceling_reservation'), {okText: 'OK'});
                        }
                    }).catch(error => {
                        this.showError(error)
                    });
                })
        },
        uncancel: function () {
            let self = this;

            self.$dialog.confirm(self.$t('really_restore'), {okText: self.$t('yes'), cancelText: self.$t('no')})
                .then(() => {
                    let data = `{
                            ${this.id ? 'id:' + this.id : ''}
                            reservation_rows: [
                                {
                                    ${this.row ? 'id: ' + this.row : ''}
                                    canceled: false
                                }
                            ]
                        }`;

                    let query = `mutation createReservation {
                        createUpdateReservation(reservation: ${data}) {
                            ok
                        }
                    }`;

                    axios({
                        data: query,
                        timeout: 10000,
                    }).then(response => {
                        if (response.data.data.createUpdateReservation.ok) {
                            self.canceled = false;
                            this.$dialog.alert(self.$t('reservation_restored'), {okText: 'OK'});
                        } else {
                            this.$dialog.alert(self.$t('error_restoring_reservation'), {okText: 'OK'});
                        }
                    }).catch(error => {
                        this.showError(error)
                    });
                });
        }
    }
}
</script>

<style scoped lang="less">
@import "../../less/_core/global/font_sizes.less";
@import "../../less/_core/theme/core/colors.less";

.guest-block {
    margin-top: 42px;

    .title {
        display: flex;
        font-weight: 500;
        padding: 0 0 8px 11px;

        label {
            font-size: @r11;
            text-transform: uppercase;
        }

        button {
            font-size: @r12;
            color: @color-c;
            display: flex;
            align-items: center;
            gap: 7px;

            .icon {
                font-size: 18px;
                vertical-align: center;
            }

            &:disabled {
                color: #B4B4B4;
                cursor: default;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/templates/comp/reservation-edit.vue